import React from "react";
import { Typography } from "antd";
import BarChartHighcharts from "../../Charts/BarChart.jsx";
import { dualBarExample } from "./ChartTypes/dualBar.jsx";
import { barAndBubbleExample } from "./ChartTypes/barAndBubble";
import { stackedBarExample } from "./ChartTypes/stackedBarChart.jsx";
import { barExample } from "./ChartTypes/bar.jsx";
import { useSelector } from "react-redux";

export const ChartPreview = ({ chartManager }) => {
    const editState = chartManager.editingChart;
    const {colorRefs} = useSelector(({ team }) => team);

    let opts = {};

    switch (editState?.chartType?.type) {
        case "grouped_bar_chart":
            opts = dualBarExample(editState.currentValue.title, editState.currentValue.subtitle_1,  editState.currentValue.subtitle_2,colorRefs.primary,colorRefs.secondary);
            break;
        case "bar_and_bubble_chart":
            opts = barAndBubbleExample(editState.currentValue.title, chartManager.getMetricName(editState.currentValue.bar_metric), chartManager.getMetricName(editState.currentValue.bubble_metric));
            break;
        case "stacked_bar_chart":
            const extractBarMetrics = (currentValue) => {
                const barMetrics = [];
                const barMetricRegex = /^bar[1-8]_metric$/;

                for (const key in currentValue) {
                    if (barMetricRegex.test(key)) {
                        barMetrics.push(chartManager.getMetricName(currentValue[key]));
                    }
                }

                return barMetrics;
            };

            const barMetricsArray = extractBarMetrics(editState.currentValue);
            opts = stackedBarExample(editState.currentValue.title, barMetricsArray);
            break;
        case "bar_chart":
            opts = barExample(editState.currentValue.title,chartManager.getMetricName(editState?.currentValue?.metric));
            break;
        default:
            opts = {};
    }
    return (<div
        style={{
            marginTop: "20px",
            marginBottom: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        }}
    >
        <Typography.Text
            type="secondary"
            italic
            style={{ marginBottom: "8px", fontSize: "12px" }}
        >
            Preview only &mdash; chart shown uses sample data, not your team's data.
        </Typography.Text>
        <BarChartHighcharts
            options={opts}
          />
    </div>)
}
